// Core Loop Tech mark — an infinity loop with animated energy flow.
export default function LogoMark({ className = "h-8 w-8" }) {
  const path =
    "M16 16 C 13 10, 6 10, 6 16 C 6 22, 13 22, 16 16 C 19 10, 26 10, 26 16 C 26 22, 19 22, 16 16 Z";
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="clg" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#67F5FF" />
          <stop offset="1" stopColor="#00A8B5" />
        </linearGradient>
      </defs>
      <path d={path} stroke="#FFFFFF" strokeOpacity="0.12" strokeWidth="4.4" strokeLinecap="round" />
      <path d={path} stroke="url(#clg)" strokeWidth="2.6" strokeLinecap="round" />
      <path d={path} stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" strokeDasharray="6 46">
        <animate attributeName="stroke-dashoffset" from="52" to="0" dur="2.4s" repeatCount="indefinite" />
      </path>
    </svg>
  );
}
